<template>
    
    <ImpulsHero id="home" class="relative md:mb-12" />

    <DienstenComponent id="diensten" class="relative md:mb-24 my-16"/>
       
    <TeamComponent id="team" class="relative md:mb-24 mb-16" />

    <!--<VisieComponent id="about" class="relative md:mb-24 mb-16" />-->
    <VisieComponent id="about" class="relative md:mb-24 mb-16" />

    <ReviewsComponent id="reviews" class="relative md:mb-24 mb-16" />

    <PartnersComponent id="partners"/>
</template>

<script>
import ImpulsHero from '@/components/impulshero/ImpulsHero.vue';
import DienstenComponent from '@/components/DienstenComponent.vue';
import VisieComponent from '@/components/VisieComponent.vue';
import TeamComponent from '@/components/TeamComponent.vue';
import PartnersComponent from '@/components/PartnersComponent.vue';
import { tns } from 'tiny-slider/src/tiny-slider';
import ReviewsComponent from '../components/ReviewsComponent.vue';
export default {
    data() {
        return {

        }
    },
    components: {
        ImpulsHero,
        DienstenComponent,
        VisieComponent,
        TeamComponent,
        PartnersComponent,
        ReviewsComponent
    },
    mounted() {
        tns({
            container: '.tiny-one-item',
            controls: true,
            mouseDrag: true,
            loop: true,
            rewind: true,
            autoplay: true,
            autoplayButtonOutput: false,
            autoplayTimeout: -1,
            navPosition: "bottom",
            controlsText: ['<i class="mdi mdi-chevron-left "></i>', '<i class="mdi mdi-chevron-right"></i>'],
            nav: false,
            speed: 1000,
            gutter: 0,
        });
    },

}

</script>

<style lang="scss" scoped></style>